// extracted by mini-css-extract-plugin
module.exports = {"display__grid":"WeatherDataPage2_display__grid__3a28X"};